import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { userActions } from '../../_actions';
import { bindActionCreators } from 'redux';
import siteConstants from '../../languages';
import { apiConstants } from '../../_constants/api.constants';

class InviteUser extends Component {
    constructor(props) {
        super(props);
                
        this.state = { };
    }

    render() {
        return ( <div className="container"> </div> );
    }
}

function mapStateToProps(state) {
    //const { loggingIn } = state.authentication;
    const { language } = state;
    return {
        //loggingIn,
        language
    };
}

//-- We can collect all action methods under the bind creator and use "actions" as a globally on page.
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Object.assign({}, userActions), dispatch)
});

const connectedLogin = connect(mapStateToProps, mapDispatchToProps)(InviteUser);
export { connectedLogin as InviteUser };